<template>
    <svg height="72" viewBox="0 0 72 72" width="72" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="nonzero">
            <circle cx="36" cy="36" fill="#48B6E7" r="36" />
            <path
                d="M27 52.554L45.43 71C60.693 66.926 72 53.007 72 36.372v-1.019L57.528 22 27 52.554z"
                fill="#55C0EF"
            />
            <g fill="#FFF">
                <path
                    d="M36.926 44.486c1.595 1.6 1.595 4.343 0 5.943l-3.305 3.314c-1.595 1.6-4.33 1.6-5.925 0L13.225 39.114c-1.595-1.6-1.595-4.343 0-5.943l3.304-3.314c1.596-1.6 4.33-1.6 5.926 0l14.47 14.629z"
                />
                <path
                    d="M49.574 19.229c1.595-1.6 4.33-1.6 5.925 0l3.305 3.314c1.595 1.6 1.595 4.343 0 5.943L33.735 53.514c-1.595 1.6-4.33 1.6-5.925 0L24.506 50.2c-1.596-1.6-1.596-4.343 0-5.943L49.574 19.23z"
                />
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: "Chat Okey",
};
</script>



// WEBPACK FOOTER //
// src/components/svg/ChatOkey.vue